import { useSelector } from "react-redux";

/**
 * Custom hook to access payment setup data from Redux store
 * - Provides clean access to payment setup state
 * - Already populated by postAuthFlow on login
 * - Follows pattern of useSubscription, useCurrencies, and useCountries
 */
export const usePaymentSetup = () => {
  const { paymentSetups, hasPaymentSetup, loading, error, paymentSetupWallChecked } = useSelector(state => ({
    paymentSetups: state.paymentSetup?.paymentSetups || [],
    hasPaymentSetup: state.paymentSetup?.hasPaymentSetup || false,
    loading: state.paymentSetup?.loading || false,
    error: state.paymentSetup?.error || null,
    paymentSetupWallChecked: state.paymentSetup?.paymentSetupWallChecked || false,
  }));

  return {
    paymentSetups,
    hasPaymentSetup,
    loading,
    error,
    paymentSetupWallChecked,
    // Helper to refresh - returns the dispatch action
    // Components can call: dispatch(refreshPaymentSetups())
  };
};
